module.exports = __webpack_public_path__ + "img/code.fbbc933d.png";